export const PAYMENT_METHOD_TYPE = {
  PIX: 'PIX',
  PIX_COB: 'PIX_COB',
  PIX_COBV: 'PIX_COBV',
  PIX_CREDIARY: 'PIX_CREDIARY',
  CREDIT_CARD: 'CREDIT_CARD',
  ITP: 'ITP',
  BOLETO: 'BOLETO',
} as const;
